import { Image } from "@/ui/image";
import { ReactNode } from "react";
import * as css from "./style.css";

export function IssueIcon(issue: { iconSrc?: string }) {
  return (
    <Image
      src={issue.iconSrc ?? "/icons/skull.svg"}
      width={40}
      height={40}
      className={css.issueIcon}
    />
  );
}

type Issue =
  | {
      message: ReactNode;
      iconSrc?: string;
    }
  | string;

export function IssuesList(props: { issues: Issue[] }) {
  return (
    <div className={css.issues}>
      {props.issues.map((issueOrMessage, index) => {
        const issue =
          typeof issueOrMessage === "string" ? { message: issueOrMessage } : issueOrMessage;

        return (
          <div className={css.issue} key={index}>
            <IssueIcon iconSrc={issue.iconSrc} />

            <div>{issue.message}</div>
          </div>
        );
      })}
    </div>
  );
}
